/**
 * Created by vadimdez on 20/01/2017.
 */
import { NgModule } from '@angular/core';
import {FilterPipePipe} from './filter-pipe.pipe';

@NgModule({
  declarations: [FilterPipePipe],
  exports: [FilterPipePipe],
  providers: [FilterPipePipe]
})
export class FilterPipeModule {}



// WEBPACK FOOTER //
// /app/src/app/pipes/filter-pipe/filter-pipe.module.ts